<div class="warehouse-create">
  <div class="warehouse-create__content">
    <div class="warehouse-create__layout">
      <div class="warehouse-create__header">
        <div class="warehouse-create__heading">
          <h1 class="page-title">Create Warehouse</h1>
          <p class="page-subtitle">Add a new warehouse with location and note details.</p>
        </div>
        <div class="warehouse-create__actions">
          <app-button type="button" variant="secondary" (click)="goBack()">Back</app-button>
          <app-button type="button" [disabled]="isSaving || warehouseForm.invalid" (click)="saveWarehouse()">
            {{ isSaving ? "Creating..." : "Create warehouse" }}
          </app-button>
        </div>
      </div>

      <app-card>
        <form [formGroup]="warehouseForm" class="warehouse-create__form">
          <div class="warehouse-create__form-field">
            <div class="warehouse-create__form-label-row">
              <label for="name" class="warehouse-create__form-label">Warehouse Name</label>
            </div>
            <input
              id="name"
              type="text"
              formControlName="name"
              class="warehouse-create__form-input"
              [class.warehouse-create__form-input--error]="warehouseForm.get('name')?.invalid && warehouseForm.get('name')?.touched" />
            @if (warehouseForm.get("name")?.invalid && warehouseForm.get("name")?.touched) {
            <div class="warehouse-create__form-error">Warehouse name is required and must be at least 2 characters</div>
            }
          </div>

          <div class="warehouse-create__form-field">
            <div class="warehouse-create__form-label-row">
              <label for="note" class="warehouse-create__form-label">Note</label>
            </div>
            <app-rich-text-editor formControlName="note" placeholder="Write warehouse notes..."></app-rich-text-editor>
          </div>
        </form>
      </app-card>

      <app-card class="warehouse-create__address-card">
        <div class="warehouse-create__section-header">
          <div>
            <h2 class="warehouse-create__section-title">Address Information</h2>
            <p class="warehouse-create__section-hint">Select the location hierarchy and provide address details.</p>
          </div>
        </div>

        <app-location-selector (addressChange)="onAddressChange($event)"></app-location-selector>
      </app-card>
    </div>
  </div>
</div>
